<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              My Resume
            </div>

            <div class="subtitle-1 font-weight-light">
              Sort by most recent development history
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    label="Project name"
                    value="SK○○표준플랫폼"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    label="Customer"
                    value="SK하이닉스"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    label="Development environment"
                    value="VUEJS, PostgreSQL, SPRING BOOT"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    value="○○○(삼성 ○○○ 및 협업 생태계) 프로젝트"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    value="삼성전자"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    value="VUEJS, ORACLE, SPRING BOOT"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    
                    value="○○○ 시스템 프로젝트"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    
                    value="삼성전자"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    value="VUEJS, PostgreSQL, SPRING BOOT"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    
                    value="○○기업(○란○산) 금융권 프로젝트"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    
                    value="중소기업중앙회"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    value="BXM, ORACLE, 웹스퀘어"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    
                    value="○○ ○칩재고 관리시스템"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    
                    value="SK하이닉스"
                    disabled
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    value="JSP, ORACLE, NEXCORE, ALOPEX"
                    disabled
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    label="About Me"
                    value="프로젝트 수행중입니다. (goodkim35@gmail.com)."
                    disabled
                  />
                </v-col>
 
                <v-col
                  cols="12"
                  md="10"
                  class="text-right"
                >
                  <v-btn
                    v-if="isLogin"
                    color="success"
                    class="mr-0"
                    @click="getActiveYn"
                  >
                    Active Check
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  md="10"
                  class="text-right"
                >
                  <v-btn
                    v-if="false"
                    color="success"
                    class="mr-0"
                    @click="dialog = true"
                  >
                    연락처 남기기
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="text-right"
                >
                  
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <base-material-card
          class="v-card-profile"
          avatar="https://demos.creative-tim.com/vue-material-dashboard/img/marc.aba54d65.jpg"
        >
          <v-card-text class="text-center">
            <h6 class="display-1 mb-1 grey--text">
              Full-stack Developer
            </h6>

            <h4 class="display-2 font-weight-light mb-3 black--text">
              Kim W. G.
            </h4>

            <p class="font-weight-light grey--text">
              Developer who enjoys development
            </p>

            <v-btn v-show="false"
              color="success"
              rounded
              class="mr-0"
            >
              Follow
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <!-- 연락처 남기기 팝업 -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">연락처 남기기</v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-text-field
              v-model="email"
              label="E-MAIL *"
              :rules="[rules.required, rules.email]"
              required
            ></v-text-field>

            <v-text-field
              v-model="phone"
              label="연락처"
            ></v-text-field>

            <v-textarea
              v-model="content"
              label="내용 *"
              :rules="[rules.required, rules.max100]"
              required
              rows="4"
              counter="100"
            ></v-textarea>
          </v-form>

          <!-- ✅ 로딩 오버레이 -->
          <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="dialog = false">닫기</v-btn>
          <v-btn color="blue darken-1" @click="submit">발송</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        email: '',
        phone: '',
        content: '',
        formValid: false,
        rules: {
          required: v => !!v || '필수 항목입니다.',
          email: v =>
            !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || '유효한 이메일을 입력하세요.',
          max100: v =>
            !v || v.length <= 100 || '100자 이내로 입력하세요.',   
        },
      };
  },
  computed: {
    isLogin() {
      return this.$store.state.user.isLogin;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if (confirm('발송 하시겠습니까?')) {
          this.loading = true;
          axios.post("/api/public/contact/submit", {
            phone: this.phone,
            email: this.email,
            content: this.content
          }).then(() => {
            this.$toast.success('성공적으로 발송되었습니다!. 곧 연락드리겠습니다.');

            this.dialog = false;
            this.resetForm();
          })
          .catch((error) => {
            const errorMessage = error.response?.data || error.message || 'Unknown error';
            alert("발송 중 오류 발생: " + errorMessage);
          })
          .finally(() => {
            this.loading = false;
          });
        }
      }
    },
    resetForm() {
      this.email = '';
      this.phone = '';
      this.content = '';
      this.$refs.form.resetValidation();
    },
   
    async sendMessage() {
      try {
        console.log('sendMessage start');
        const res = await axios.post('/api/public/triggerHourly');
        //const res = await axios.post('/api/public/triggerDayly');
        alert(res.data);
      } catch (err) {
        console.error('Axios error:', err);
        const errorMessage = err.response?.data || err.message || 'Unknown error';
        alert('Failed to trigger job: ' + errorMessage);
      }
    },
    async getActiveYn(){
      try {
        console.log('getActiveYn start');
        const res = await axios.get('/api/getActiveYn');
        
        alert(res.data);
      } catch (err) {
        console.error('Axios error:', err);
        const errorMessage = err.response?.data || err.message || 'Unknown error';
        alert('Failed to trigger job: ' + errorMessage);
      }
    } 
    
  }
}
</script>
